function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 0.658691C0.447715 0.658691 0 1.10641 0 1.65869V59.6587C0 60.211 0.447715 60.6587 1 60.6587H59C59.5523 60.6587 60 60.211 60 59.6587C60 59.1064 59.5523 58.6587 59 58.6587H2V1.65869C2 1.10641 1.55228 0.658691 1 0.658691Z",
  fill: "#9F9A98"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12.5,
  cy: 28.1587,
  r: 2.5,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 27.5,
  cy: 21.1587,
  r: 3.5,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 53.5,
  cy: 50.1587,
  r: 3.5,
  stroke: "#9F9A98",
  strokeWidth: 2
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 34.5,
  cy: 45.1587,
  r: 3.5,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 27.5,
  cy: 5.15869,
  r: 1.5,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref8 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 48.5,
  cy: 35.1587,
  r: 1.5,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5 50.1587V51.1587H13.9142L14.2071 50.8658L13.5 50.1587ZM59.5 4.15869L48.3465 7.14728L56.5114 15.3122L59.5 4.15869ZM2 51.1587H13.5V49.1587H2V51.1587ZM14.2071 50.8658L53.8431 11.2298L52.4289 9.81555L12.7929 49.4516L14.2071 50.8658Z",
  fill: "#3C3C3B"
});

var SvgFeatureOne1 = function SvgFeatureOne1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeatureOne1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FeatureOne-1.750d59fe.svg";
export { ForwardRef as ReactComponent };